export default {
  menuItems: [
    {
      name: 'HOME',
      url: '/'
    },
    {
      name: 'RANDOM',
      url: '/random'
    },
    {
      name: 'LIST',
      url: '/list'
    },
    {
      name: 'EDIT',
      url: '/edit'
    },
    {
      name: 'DOCS',
      url: '/docs'
    },
    {
      name: 'FEEDBACK',
      url: '/feedback'
    }
    // {
    //   name: 'LABO',
    //   url: '/about'
    // }
  ]
}
